import React, { Component } from "react";
// import Header from './Header.js'
// import Footer from './Footer';
import ProjPeopleContent from "./ProjPeopleContent";
/**
 * Project Implementation Team
 */
const data = {
  header: ["S. No. ", "Project ", "Team", "Responsibility"],
  rows: {
    row1: [
      "1",
      "Development of Web Enabled Hydrological Modelling in SWAT",
      "Ms. Annie Maria Issac, S/E 'SE'",
      "Principal Investigator",
    ],
    row2: [
      "",
      "",
      "Ms. Asiya Begum, S/E 'SF'",
      "Co-Principal Investigator",
    ],
    row3: [
      "2",
      "Operational Hydrological Drought Services using Remote Sensing Data",
      "Shri. K. Bharath Kumar Reddy, S/E 'SD'",
      "Principal Investigator",
    ],
    row4: [
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SE'",
      "Co-Principal Investigator",
    ],

    row5: [
      "3",
      "Water Information Systems Development & Dissemination",
      "Shri. Anurag Mishra, S/E 'SD'",
      "Principal Investigator",
    ],
    row6: [
      "",
      "",
      "Shri. K. Sachin Prakash, S/E 'SD'",
      "Co-Principal Investigator",
    ],
    row7: [
      "",
      "",
      "Shri. J. Sai Rama Krishna, S/E 'SD' (till 19-Jun-2024)",
      "Co-Principal Investigator",
    ],

    row8: [
      "4",
      "Real-time Operational Spatial Flood Early Warning System Development",
      "Shri. Amanpreet Singh, S/E 'SE'",
      "Principal Investigator",
    ],
    row9: [
      "",
      "",
      "Shri. Abinav Kumar Shukla, S/E 'SE'",
      "Co-Principal Investigator",
    ],
    row10: [
      "5",
      "Satellite Data-based Irrigation Scheduling for a Selected Irrigation Project Command Area",
      "Ms. Annie Maria Issac, S/E 'SE'",
      "Principal Investigator",
    ],
    row11: [
      "",
      "",
      "Shri. K. Sachin Prakash, S/E 'SD'",
      "Co-Principal Investigator",
    ],
    row12: [
      "6",
      "Glacial Lake Outburst Flood (GLOF) Risk Assessment",
      "Shri. Saksham Joshi, S/E 'SE'",
      "Principal Investigator",
    ],
    row13: [
      "",
      "",
      "Shri. C. Sai Krishna, S/E 'SD'",
      "Co-Principal Investigator",
    ], 
    row14: [
      "7",
      "Development of Satellite-based Regional Evaporative Flux Monitoring System for India",
      "Shri. J. Mohamed Ahmed, S/E 'SF'",
      "Principal Investigator (EC Flux Tower Data Analysis and R&D Studies)",
    ],
    row15: [
      "",
      "",
      "Smt. Nidhi Misra, S/E 'SE'",
      "Principal Investigator (ET Product Generation & Validation)",
    ],
    row16: [
      "",
      "",
      "Shri. Anurag Mishra, S/E 'SD'",
      "Co-Principal Investigator",
    ],
    row17: [
      "",
      "",
      "Shri. K. Sachin Prakash, S/E 'SD'",
      "Co-Principal Investigator",
    ],  
    row18: [
      "8",
      "Development of Spatial Snowmelt Runoff Product in the Indian Himalayas",
      "Shri. C. Sai Krishna, S/E 'SD'",
      "Principal Investigator",
    ],
    row19: [
      "",
      "",
      "Shri. Saksham Joshi, S/E 'SE'",
      "Co-Principal Investigator",
    ],
    row20: [
      "9",
      "Operational National Hydrological Modelling System for the Entire Country",
      "Shri. Saksham Joshi, S/E 'SE'",
      "Principal Investigator",
    ],
    row21: [
      "",
      "",
      "Shri. Anurag Mishra, S/E 'SD'",
      "Co-Principal Investigator",
    ],
    row22: [
      "10",
      "Customised RS&GIS Training and Capacity Building",
      "Shri. P.V.S.S.N Gopalakrishna, S/E 'SG'",
      "Principal Investigator",
    ],
    row23: [
      "",
      "",
      "Shri. T.S. Viswanadham, S/E 'SF'",
      "Co-Principal Investigator",
    ],
  },
};




const data1 = {
  header: ["S. No. ", "Project ", "Team", "Responsibility"],
  rows: {
    row1: [
      "1",
      "Spatial Flood Early Warning System",
      "Shri.  Amanpreet  Singh,  S/E 'SE',FMD, DMSG ",
      "Principal Investigator",
    ],
    row2: [
      "",
      "",
      "Shri. Abinav Kumar Shukla, S/E 'SE', RC(North)",
      "Co-Principal Investigator",
    ],
    row3: [
      "2",
      "Regional  Evaporative Flux Monitoring System",
      "Dr. K. Chandrasekar, Head, WRP&DD, WRG",
      "Principal Investigator",
    ],
    row4: [
      "",
      "",
      "Shri.  J. Mohamed Ahmed, S/E 'SF', RC (South)",
      "Co-Principal Investigator",
    ],
    row5: ["", "", "Smt. Nidhi Misra,  S/E 'SE', WRP&DD, WRG", "Co-Principal Investigator"],
    row6: [
      "",
      "",
      "Shri.  Anurag  Mishra, S/E 'SD', WRID, WRG, RSAA",
      "Co-Principal Investigator",
    ],
    row7: [
      "3",
      "Glacial Lake Outburst Flood (GLOF) Risk Assessment ",
      "Shri. B. Simhadri Rao, S/E 'SG',Head, WRAD,WRG, RSAA ",
      "Principal Investigator",
    ],
    row8: [
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SE', WRID, WRG, RSAA ",
      "Co-Principal Investigator",
    ],
    row9: [
      "4",
      "Spatial Snow melt  Runoff Estimation",
      "Shri. B. Simhadri Rao, S/E 'SG', WRAD, WRG,RSAA ",
      "Principal Investigator",
    ],
    row10: [
      "",
      "",
      "Shri. Saksham Joshi, S/E  'SE',WRAD, WRG, RSAA",
      "Co-Principal Investigator",
    ],
    row11: [
      "5",
      "Operational Web based National Hydrological Modelling System",
      "Shri. Saksham Joshi, S/E 'SE', WRAD, WRG, RSAA",
      "Principal Investigator",
    ],
    row12: [
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SE', WRID, WRG, RSAA",
      "Co-Principal Investigator",
    ],
    row13: [
      "6",
      " Satellite data based Inputs for Irrigation Scheduling ",
      "Dr. V.M. Choudhary, Group Director, ASAG",
      "Principal Investigator",
    ],
    row14: [
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SE', WRID, WRG, RSAA",
      "Co-Principal Investigator",
    ],
    row15: [
      "7",
      " Operational Hydrological Drought Services",
      " Dr. A.V. Suresh Babu, Head,FMRAD",
      "Principal Investigator",
    ],
    row16: [
      "",
      "",
      "Shri. T.P. Girish Kumar, S/E 'SF', RC (Central)",
      "Co-Principal Investigator",
    ],
    row17: [
      "",
      "",
      "Shri. K. Bharath Kumar Reddy, S/E 'SD', WRID, WRG",
      "Co-Principal Investigator",
    ],
    row18: [
      "8",
      "Customized RS & GIS Training and Capacity Building",
      "Shri. P.V.S.S.N Gopalakrishna, Head, TPCD, TEOG",
      "Team Lead",
    ],
    row19: [
      "",
      "",
      "Shri. T.S. Viswanadham, TOFM, TEOG",
      "Team Member",
    ],
    row20: [
      "",
      "",
      "Ms. Annie Maria Issac, S/E 'SE',WRID, WRG, RSAA",
      "Team Member",
    ],
    row21: ["", "", "Shri. P. Hariesh, S/E 'SF', TEOG", "Team Member"],
    row22: [
      "9",
      "Aerial Data, Acquisition & Processing Team",
      "Shri. K. Venkateswar Rao , S/E 'SG', AS & DM",
      "Team Lead",
    ],
    row23: ["", "", "Shri. J. Narendran, 'SG', Group Head, NSG, ASDMA", "Team Member"],
    row24: ["", "", "Shri. S. Madhusudhan  Reddy, S/E 'SF', ASDMA", "Team Member"],
    row25: ["", "", "Shri. N. Madhusudhan  Reddy, S/E 'SF', ASDMA", "Team Member"],
    row26: ["", "", "Shri. C S Narasimham,  S/E 'SE', ASDMA ", "Team Member"],
    row27: [
      "",
      "",
      "Shri. P Shashivardan Reddy S/E 'SF', ASDMA ",
      "Team Member",
    ],

    row28: ["", "", "Shri. B Satish,  S/E 'SE', ASDMA ", "Team Member"],
    row29: [
      "10",
      "Bhuvan Products & Services",
      "Shri. K Kalyan Deep, S/E 'SF', VASD, CGVAG",
      "Team Lead",
    ],
    
    row31: ["", "", "Shri. J Sai Rama Krishna, S/E 'SD', BWSD, BG & WSG", "Team Member"],
    row30: ["", "", "Shri. R S Vijay Krishna, S/E 'SD', BWSD, BG & WSG", "Team Member"],
  },
};
export default class ProjImplement extends Component {
  render() {
    return (

      <div>
      <div
        style={{ padding: "15px"}}
        className="card"
      >
        <h3 style={{ textAlign: "center", color: "#002120" }}>
        Project Implementation Team 
        </h3>
        </div>
        {/* <h5 style={{textAlign:"right",color: "#002171",margin:"0px",padding:"0px"}}> *Note: Red color denotes Ex-Employees</h5> */}
        <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
          <ProjPeopleContent data={data} /></div>


          <div
        style={{ padding: "15px" }}
        className="card"
      >
        <h3 style={{ textAlign: "center", color: "#002120"}}>
        Project Implementation Team (19-Mar-2018 to 27-Jun-2023)
        </h3>
          </div>
       
        <div className="card-body" style={{width:"70vw",margin:"0 auto"}} >
          <ProjPeopleContent data={data1} width="70%" />
        </div>
      </div>
    );
  }
}
